import { render, staticRenderFns } from "./regest.vue?vue&type=template&id=aab3f73e&scoped=true&"
import script from "./regest.vue?vue&type=script&lang=js&"
export * from "./regest.vue?vue&type=script&lang=js&"
import style0 from "./regest.vue?vue&type=style&index=0&id=aab3f73e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aab3f73e",
  null
  
)

export default component.exports